import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-fab-button',
  templateUrl: './fab-button.component.html',
  styleUrls: ['./fab-button.component.less'],
  host: {
    '[class]': 'context + " " + shape',
    '[class.active]': 'isActive',
  },
})
export class FabButtonComponent {
  @Input() public context: 'light' | 'dark';
  @Input() public shape: 'circular' | 'rectangular' = 'rectangular';
  @Input() public isActive: boolean = false;
}
